import { hideElement, showElement } from './setElIsHidden';

export { showElement, hideElement };
